<template>
  <div>
    <b-overlay
      :show="loader"
      rounded="sm"
    >
      <b-col
        v-if="epicfail===null && !isEmptyObject(ItemTran) "
        lg="12"
        md="12"
      >
        <app-collapse
          type="margin"
          class="mb-2"
        >
          <app-collapse-item :title="`Detalle de la transacción ${ItemTran.id || 'No disponible'}`">
            <b-list-group>
              <!-- Iteramos sobre las propiedades del objeto ItemTran -->
              <b-list-group-item
                v-for="(value, key, index) in filteredItemTran"
                :key="index"
              >
                <strong>{{ key }}:</strong>
                {{ value === 'null' || value === null ? 'No disponible' : value }}
              </b-list-group-item>
            </b-list-group>
          </app-collapse-item>
        </app-collapse>

        <b-input-group prepend="Motivo">
          <b-form-textarea
            id="txtobservaciones"
            v-model="formdata.observaciones"
            placeholder="Ingrese el motivo de cancelación."
            rows="3"
            no-resize
          />
        </b-input-group>
        <b-alert
          class="mt-2"
          show
          variant="warning"
        >
          <div class="alert-body">
            <feather-icon
              class="mr-25 large-icon"
              icon="AlertCircleIcon"
            />
            <span class="ml-25">Revisar que esta transacción no este asociada un plan de pagos.</span>
          </div>
        </b-alert>
        <div class="d-block mt-2 text-center">
          <b-button
            v-show="ItemTran.status == 'ACT'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="handleOk()"
          >
            <b-spinner
              v-show="flagproceder"
              small
              type="grow"
            />
            {{ (flagproceder) ? 'Trabajando...': 'Proceder' }}
          </b-button>
          <b-alert
            v-show="ItemTran.status=='CAN'"
            class="mt-2"
            show
            variant="info"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="InfoIcon"
              />
              <span class="ml-25">Esta transacción ya fue cancelada.</span>
            </div>
          </b-alert>
        </div>
      </b-col>
      <b-col v-else>
        <b-card
          border-variant="warning"
          title="Lo sentimos, problemas al cargar la transacción"
          bg-variant="transparent"
          class="shadow-none"
        >
          <b-card-text>
            Lo sentimos, [ {{ epicfail }} ]. estaremos de vuelta tan pronto sea posible.
          </b-card-text>
        </b-card>
      </b-col>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCol,
  BAlert,
  BInputGroup,
  BFormTextarea,
  BButton,
  BSpinner,
  BCard,
  BCardText,
  BListGroup,
  BListGroupItem,
  BOverlay,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { frmstatus } from '@core/utils/filter'
import { isEmptyObject } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import { RESUMEN_X_TRAN } from './useTareas'

export default {
  components: {
    BCol,
    BAlert,
    BInputGroup,
    BFormTextarea,
    BButton,
    BSpinner,
    BCard,
    BCardText,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    BOverlay,
  },
  directives: {
    Ripple,
  },
  props: {
    transaccion: {
      type: Number,
      require: true,
      default: () => null,
    },
    openModal: {
      type: Boolean,
      require: true,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    // Definición de variables reactivas
    const flagproceder = ref(false)
    const loader = ref(false)
    const userRole = computed(() => {
      const role = store.state.cuenta.rolSelected
      // Si `rolSelected` es nulo, indefinido o vacío, asigna un objeto vacío
      return role || {}
    })
    const toast = useToast()
    const ItemTran = ref({})
    const planItemTran = ref({})
    const formdata = ref({
      observaciones: null,
      transaccion: null,
      factura: null,
      urol: null,
      action: 8,
    })
    const epicfail = ref(null)

    const resetModal = () => {
      formdata.value = {
        observaciones: null,
        transaccion: null,
      }
    }

    // Lista de claves a ocultar
    const ocultarClaves = ref(['id', 'factura', 'refPEF', 'rutaDoc', 'extBase'])

    // Computed que filtra el objeto
    const filteredItemTran = computed(() => {
      if (!ItemTran.value) return {} // Si aún no hay datos, devolvemos un objeto vacío
      return Object.fromEntries(
        Object.entries(ItemTran.value).filter(([key]) => !ocultarClaves.value.includes(key)),
      )
    })

    // Funciones
    const TranReject = async datos => {
      try {
        flagproceder.value = true

        const response = await store.dispatch('compras/postCompras', datos)

        if (response.status !== 200) {
          throw new Error(response.message)
        }

        flagproceder.value = false

        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: response.message,
            icon: 'CheckSquareIcon',
            variant: 'success',
          },
        }, { timeout: 6000, position: 'top-center' })
        // clear form
        resetModal()
        emit('update:openModal', false) // Emite el evento con el nuevo valor
        emit('reload-data')
      } catch (error) {
        flagproceder.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: error || 'Ocurrió un error inesperado',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        }, { timeout: 10000 })
      }
    }

    const fetchTran = async iden => {
      try {
        //  GET DATA
        loader.value = true
        const response = await RESUMEN_X_TRAN(iden)
        const { status, message, resumen } = response
        if (status === 200) {
          ItemTran.value = resumen
          epicfail.value = null // Limpiar cualquier error previo
          // configurar request
          const { factura } = ItemTran.value
          formdata.value.transaccion = props.transaccion
          if (factura != null) formdata.value.factura = factura

          // set rol current
          if (!isEmptyObject(userRole)) formdata.value.urol = userRole.value.id
        } else epicfail.value = message
        loader.value = false
      } catch (err) {
        loader.value = false
        epicfail.value = `Error al obtener el resumen de la transaccion: ${err.message || err}`
        ItemTran.value = {} // Limpiar datos previos en caso de error
      }
    }

    const handleOk = () => {
      if (formdata.value.observaciones !== null && formdata.value.observaciones.length >= 15) {
        TranReject(formdata.value)
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Es importante ingrese el motivo y debe ser mayor a 15 caracteres',
            icon: 'AlertCircleIcon',
            variant: 'warning',
            solid: true,
          },
        }, { timeout: 10000 })
      }
    }

    // Ciclo de vida
    onMounted(async () => {
      if (props.transaccion) {
        await fetchTran(props.transaccion)
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Por favor instale el componente correctamente, transaccion no encontrada',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        }, { timeout: 10000 })
      }
    })

    // Retornar las propiedades y métodos que se usarán en la plantilla
    return {
      formdata,
      ItemTran,
      planItemTran,
      epicfail,
      filteredItemTran,
      // flags
      flagproceder,
      loader,
      // functions
      TranReject,
      frmstatus,
      isEmptyObject,
      handleOk,
    }
  },
}
</script>

    <style scoped>
    /* Estilos específicos del componente */
    p {
      color: #42b983;
    }
    .large-icon {
      font-size: 2em;
    }
    </style>
